import cx from 'classnames';
import { Tab } from 'components/auth/ManageYourBooking';
import { AppViews } from 'endpoints';
import { ReactComponent as BookingSvg } from 'images/booking.svg';
import { ReactComponent as BuySvg } from 'images/buy2.svg';
import { ReactComponent as CloseSvg } from 'images/icons/iconfinder_x.svg';
import { User } from 'models/User';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { IStore } from 'store/reducers';
// import { isAdmin } from 'utils/isAdmin';
import { isAdmin } from 'utils/isAdmin';
import styles from './Sidebar.module.css';
import { LinkRouter } from './Link';

interface Props {
  displaySidebar: boolean;
  handleHideSidebar: () => void;
}

const Sidebar: React.FC<Props> = ({ displaySidebar, handleHideSidebar }) => {
  const { t } = useTranslation();
  const token = useSelector<IStore, string | null>((state) => state.authAgency.token);
  const currentUser = useSelector<IStore, User | null>((state: IStore) => state.users.currentUser);

  const ref = React.useRef<HTMLDivElement>(null);

  const handleOutsideClick = React.useCallback(
    (e: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current?.contains(e.target as Node)) return;

      handleHideSidebar();
    },
    [handleHideSidebar],
  );

  React.useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    document.addEventListener('touchstart', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, [handleOutsideClick]);

  return (
    <>
      <div className={cx(styles.background, { [styles.overlay]: displaySidebar })} />

      <div ref={ref} className={`${styles.sidebar} ${displaySidebar ? styles.show : ''}`}>
        <div className={`${styles.sidebarContent} ${displaySidebar ? styles.show : styles.hide}`}>
          <div className={styles.topSideBar}>
            <CloseSvg onClick={handleHideSidebar} className={styles.close} />
            {token ? (
              <>
                {currentUser?.firstName && (
                  <p>
                    {t(`views:sidebar.hello`)} {currentUser?.firstName} {currentUser?.lastName}
                  </p>
                )}
                <LinkRouter to={AppViews.AGENCY} onClick={handleHideSidebar}>
                  PAINEL
                </LinkRouter>
              </>
            ) : (
              <Link
                to={{ pathname: AppViews.AGENCY_LOGIN, state: { tab: Tab.haveAnAccount } }}
                onClick={handleHideSidebar}
              >
                {t('views:sidebar.signIn')}
              </Link>
            )}
          </div>

          <div className={styles.staticPages}>
            <LinkRouter to={{ pathname: AppViews.HOME, state: 'no-access-checkout' }} onClick={handleHideSidebar}>
              <BuySvg />
              <span>Vender bilhete</span>
            </LinkRouter>
            {/* <hr />

            <Link
              to={{ pathname: AppViews.AGENCY_REPORTS, state: { tab: Tab.haveBookingId } }}
              onClick={handleHideSidebar}
            >
              <BookingSvg />
              <span>Relatórios</span>
            </Link> */}
            <hr />
            <LinkRouter
              to={{ pathname: AppViews.AGENCY_NEW_REPORTS, state: { tab: Tab.haveBookingId } }}
              onClick={handleHideSidebar}
            >
              <BookingSvg />
              <span>Caixa</span>
            </LinkRouter>
            <hr />
            <LinkRouter
              to={{ pathname: AppViews.AGENCY_TICKETS, state: { tab: Tab.haveBookingId } }}
              onClick={handleHideSidebar}
            >
              <BookingSvg />
              <span>Consultar Bilhetes</span>
            </LinkRouter>
            <hr />

            {isAdmin() && (
              <>
                <LinkRouter
                  to={{ pathname: AppViews.AGENCY_PAYMENTS, state: { tab: Tab.haveBookingId } }}
                  onClick={handleHideSidebar}
                >
                  <BookingSvg />
                  <span>Pagamentos</span>
                </LinkRouter>
                <hr />
              </>
            )}

            <LinkRouter
              to={{ pathname: AppViews.AGENCY_SETTINGS, state: { tab: Tab.haveBookingId } }}
              onClick={handleHideSidebar}
            >
              <BookingSvg />
              <span>Configuração</span>
            </LinkRouter>
            <hr />
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
